// extracted by mini-css-extract-plugin
module.exports = {"infoButton":"range-estimation_infoButton__rpG6u"};